import { gql } from "@apollo/client";

export const USE_QUICK_WESENTLICHKEIT = gql`
    mutation UseQuickWesentlichkeit($documents: [String!]) {
        useQuickWesentlichkeit(documents: $documents) {
            id
            status
            submittedAt
        }
    }
`; 